import React from 'react';
import { Button } from 'reactstrap';

const Chat_File_Upload_Item = ({ files, setfiles }) => {
  const onRemove_File = (file_name) => {
    const filteredFiles = files.filter(file => file.name !== file_name);
    setfiles(filteredFiles);
  };

  const renderFileItem = (file, index) => {
    let fileType = file.type;
    let type = 'Unknown';

    // Type detection based on MIME type or file extension fallback
    if (fileType.includes('pdf')) {
      type = 'PDF Document';
    } else if (fileType.includes('msword')) {
      type = 'Word Document (DOC)';
    } else if (fileType.includes('vnd.openxmlformats-officedocument.wordprocessingml.document')) {
      type = 'Word Document (DOCX)';
    } else if (fileType.startsWith('image/')) {
      type = 'Image';
    } else if (fileType.includes('plain') || file.name.endsWith('.txt')) {
      type = 'Text File';
    } else if (fileType.includes('csv') || file.name.endsWith('.csv')) {
      type = 'CSV File';
    }

    const iconMap = {
      'PDF Document': 'ri-file-pdf-line',
      'Word Document (DOC)': 'ri-file-word-line',
      'Word Document (DOCX)': 'ri-file-word-line',
      'Image': 'ri-image-line',
      'Text File': 'ri-file-text-line',
      'CSV File': 'ri-file-excel-line'
    };

    const wrapperClass = {
      'PDF Document': 'pdf_upload',
      'Word Document (DOC)': 'file_upload',
      'Word Document (DOCX)': 'file_upload',
      'Image': 'image_upload',
      'Text File': 'file_upload',
      'CSV File': 'file_upload'
    };

    if (type === 'Unknown') return null;

    return (
      <div key={index} className={`n-width ${wrapperClass[type]} bg-success-subtle`}>
        <Button onClick={() => onRemove_File(file.name)} type="button" color="light">
          <i className='ri-close-circle-line'></i>
        </Button>
        <span className='text-success'>
          <i className={`text-success ${iconMap[type]}`}></i>
        </span>
        <span className='text-success'>{file.name}</span>
      </div>
    );
  };

  return (
    <div className='fileuploaditems'>
      {files.map((file, index) => renderFileItem(file, index))}
    </div>
  );
};

export default Chat_File_Upload_Item;
